import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useEffect, useState } from 'react';
import EfVideo from '@elem/ui/ef-video';
import EfIcon from '@elem/ui/ef-icon';

export default function TheComp() {
    const { t: t1 } = useLang('rapid.AniACard1');
    const { t: t2 } = useLang('rapid.AniACard2');
    const { t: t3 } = useLang('rapid.AniACard3');
    const [enterB1, setEnterB1] = useState(false);
    const [enterB2, setEnterB2] = useState(false);
    const [enterB3, setEnterB3] = useState(false);

    const [enter1, setEnter1] = useState(false);
    const [enter2, setEnter2] = useState(false);
    const [enter3, setEnter3] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            AniContainer.create({
                triggerElement: '.rapid .rapid-C',
                triggerHook: 1,
                onEnter: () => setEnterB1(true),
            });
            AniContainer.create({
                triggerElement: '.rapid .rapid-C',
                triggerHook: 1,
                offset: '50%',
                onEnter: () => setEnterB2(true),
            });
            AniContainer.create({
                triggerElement: '.rapid .rapid-C',
                triggerHook: 1,
                offset: '100%',
                onEnter: () => setEnterB3(true),
            });

            AniContainer.create({
                triggerElement: '.rapid .rapid-E',
                triggerHook: 1,
                offset: '50%',
                duration: '100%',
                onEnter: () => {
                    setEnter1(true);
                    setEnter2(false);
                    setEnter3(false);
                },
                onLeave: () => setEnter1(false),
            });

            AniContainer.create({
                triggerElement: '.rapid .rapid-E',
                triggerHook: 1,
                offset: '150%',
                duration: '100%',
                onEnter: () => {
                    setEnter1(false);
                    setEnter2(true);
                    setEnter3(false);
                },
                onLeave: () => setEnter2(false),
            });

            AniContainer.create({
                triggerElement: '.rapid .rapid-E',
                triggerHook: 1,
                offset: '250%',
                duration: '250%',
                onEnter: () => {
                    setEnter1(false);
                    setEnter2(false);
                    setEnter3(true);
                },
                onLeave: () => setEnter3(false),
            });
        }
    }, []);

    const items = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1729517560369/pc_1.mp4',
            h5: 'https://websiteoss.ecoflow.com/upload/video/1729517604583/m_1.mp4',
            poster: 'https://websiteoss.ecoflow.com/upload/image/1729655015843/pc1.jpg',
            posterH5: 'https://websiteoss.ecoflow.com/upload/image/1729655015812/m1.jpg',
            title: t1('title'),
            desc: t1.rich('desc', {
                sup: (text: string) => <sup className="sup">{text}</sup>,
            }),
            speed: t1('tips'),
            subs: [
                {
                    text: t1('a_text1'),
                    num: t1('a_text2'),
                    unit: t1('a_text3'),
                },
                {
                    text: t1('b_text1'),
                    num: t1('b_text2'),
                    unit: t1('b_text3'),
                },
            ],
            greenText: t1.rich('green_text1', {
                unit: (text: string) => <span className="unit">{text}</span>,
            }),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1729517576023/pc_2.mp4',
            h5: 'https://websiteoss.ecoflow.com/upload/video/1729517611523/m_2.mp4',
            poster: 'https://websiteoss.ecoflow.com/upload/image/1729655015843/pc2.jpg',
            posterH5: 'https://websiteoss.ecoflow.com/upload/image/1729655015820/m2.jpg',
            title: t2('title'),
            desc: t2.rich('desc', {
                sup: (text: string) => <sup className="sup">{text}</sup>,
            }),
            speed: t2.rich('tips', {
                sup: (text: string) => <sup className="sup">{text}</sup>,
            }),
            subs: [
                {
                    text: t2('a_text1'),
                    num: t2('a_text2'),
                    unit: t2('a_text3'),
                },
                {
                    text: t2.rich('b_text1', {
                        sup: (text: string) => <sup className="sup">{text}</sup>,
                    }),
                    num: t2('b_text2'),
                    unit: t2('b_text3'),
                },
            ],
            greenText: t2.rich('green_text1', {
                unit: (text: string) => <span className="unit">{text}</span>,
            }),
            greenTextMini: t2('green_text2'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/video/1729517525547/pc_3.mp4',
            h5: 'https://websiteoss.ecoflow.com/upload/video/1729517629510/m_3.mp4',
            poster: 'https://websiteoss.ecoflow.com/upload/image/1729655015843/pc3.jpg',
            posterH5: 'https://websiteoss.ecoflow.com/upload/image/1729655015820/m3.jpg',
            title: t3('title'),
            desc: t3.rich('desc', {
                sup: (text: string) => <sup className="sup">{text}</sup>,
            }),
            speed: t3('tips'),
            subs: [
                {
                    text: t3('a_text1'),
                    num: t3('a_text2'),
                    unit: t3('a_text3'),
                },
                {
                    text: t3.rich('c_text1', {
                        sup: (text: string) => <sup className="sup">{text}</sup>,
                    }),
                    num: t3('c_text2'),
                    unit: t3('c_text3'),
                },
            ],
        },
    ];

    return (
        <div className={`${css.comp} rapid-E`}>
            <div className="sticky-box">
                <ul className="sections">
                    {items?.map((item: any, k: number) => (
                        <li className={`section s${k + 1}${enter1 ? ' enter1' : ''}${enter2 ? ' enter2' : ''}${enter3 ? ' enter3' : ''}`} key={k}>
                            <div className="item-video">
                                {((k === 0 && enterB1) || (k === 1 && enterB2) || (k === 2 && enterB3)) && (
                                    <EfVideo pc={item.pc} h5={item?.h5} poster={item?.poster} posterH5={item?.posterH5} autoPlay loop />
                                )}
                                {item?.greenText && (
                                    <>
                                        <div className="item-green-text">
                                            {item?.greenText}
                                            {item?.greenTextMini && <p className="item-green-text-mini">{item?.greenTextMini}</p>}
                                        </div>
                                    </>
                                )}
                            </div>
                            <div className="item-info">
                                {/* {k === 0 && (
                                    <div className="item-icon">
                                        <EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1725431644756/m_ksp_02.svg" />
                                    </div>
                                )} */}
                                <p className="item-title">{item.title}</p>
                                <p className="item-desc">{item.desc}</p>
                                <div className="item-prog">
                                    <p className="item-speed">{item.speed}</p>
                                    <ul className="subs">
                                        {item?.subs?.map((sub: any, m: number) => (
                                            <li className={`sub ${m === 0 ? 'color' : ''}`} key={k + '_' + m}>
                                                <span className="sub-text">{sub.text}</span>
                                                <span className="sub-bar"></span>
                                                <div className="sub-desc">
                                                    <span className="sub-num">{sub.num}</span>
                                                    <span className="sub-unit">{sub.unit}</span>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
